<h2 mat-dialog-title>Edit Invoice</h2>
<mat-dialog-content>
  <div [formGroup]="form" class="flex flex-col items-stretch justify-start">
    <mat-form-field>
      <mat-label>Purchase order</mat-label>
      <input
        matInput
        placeholder="Purchase order"
        formControlName="purchase_order"
      />
    </mat-form-field>
    <span class="basis-1/3 pr-4">Invoice Type:</span>
    <mat-radio-group
      formControlName="account"
      class="flex flex-col basis-2/3"
      [required]="true"
    >
      <mat-radio-button class="example-radio-button" [value]="true">
        Account
      </mat-radio-button>
      <mat-radio-button class="example-radio-button" [value]="false">
        Cash
      </mat-radio-button>
    </mat-radio-group>

    <ng-container *ngIf="currencies$ | async as currecies">
      <ng-container *ngIf="currecies.length > 1">
        <mat-form-field>
          <mat-label>Currency</mat-label>
          <mat-select
            mat-form-field-control
            placeholder="Currency"
            name="Currency"
            id="currency"
            name="Currency"
            formControlName="currency_code"
            required="true"
          >
            <mat-option *ngFor="let currency of currecies" [value]="currency">{{
              currency
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="(hideCurrencyRateField$ | async) === false">
          <mat-label>Conversion rate</mat-label>
          <input
            matInput
            formControlName="currency_rate"
            name="Conversion rate"
            placeholder="Conversion rate"
            required="true"
          />
        </mat-form-field>
      </ng-container>
    </ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button color="primary" mat-button (click)="save()" [disabled]="form.invalid">
    Save
  </button>
</mat-dialog-actions>
